(function () {
    'use strict';

    angular
        .module('sod.helper')
        .directive('customCartItem', customCartItem);

    function customCartItem(CommonHelper, lodash) {
        return {
            restrict: 'E',
            controller: customCartItemCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                item: '=',
                addToCart: '&?',
                removeFromCart: '&?',
                isActive: '&?',
            },
            templateUrl: function(tElement, tAttrs) {
                var template = lodash.get(tAttrs, 'template', '');
                if (CommonHelper.isEmpty(template)) {
                    return template;
                } else {
                    return 'common/components/cart/cart-item';
                }
            }
        };
    }

    function customCartItemCtrl() {
        var vm = this;

    }
})();